import { QueryOptions } from "../components/Common/useQuery";
import useUserOrEmployeeQuery from "../components/Common/useUserOrEmployeeQuery";
import { useSelectedBusiness } from "../components/UserAccess/useSelectedBusiness";
export interface SharedSiteDto {
  siteId: string;
  siteName: string;
  businessName: string;
}

const useGetSharedSites = (options?: QueryOptions<SharedSiteDto[]>) => {
  const business = useSelectedBusiness();

  return useUserOrEmployeeQuery<SharedSiteDto[]>(
    { path: `/api/businesses/${business.id}/dataSharing/connections/sharedSites` },
    options);
}

export default useGetSharedSites;
